<template>
    <Card title="Recommendations">
      <div class="text-gray-600 text-sm mb-4">Best practices and tips for your system</div>
      <div class="space-y-3">
        <div class="flex items-start gap-3">
          <span class="bg-green-500 text-white rounded-full px-3 py-1 text-xs font-semibold">Security</span>
          <div>
            <div class="font-semibold text-gray-900">Enable Multi-Factor Authentication</div>
            <div class="text-gray-500 text-xs">Increase account security by requiring a second verification step.</div>
          </div>
        </div>
        <div class="flex items-start gap-3">
          <span class="bg-gray-200 text-gray-700 rounded-full px-3 py-1 text-xs font-semibold">Backup</span>
          <div>
            <div class="font-semibold text-gray-900">Schedule Regular Backups</div>
            <div class="text-gray-500 text-xs">Keep your data safe by automating daily backups.</div>
          </div>
        </div>
        <div class="flex items-start gap-3">
          <span class="bg-yellow-400 text-white rounded-full px-3 py-1 text-xs font-semibold">Monitoring</span>
          <div>
            <div class="font-semibold text-gray-900">Review Access Logs</div>
            <div class="text-gray-500 text-xs">Identify potential suspicious activities by monitoring logs.</div>
          </div>
        </div>
      </div>
    </Card>
  </template>

<script>
import Card from '../../Card.vue'
export default {
  name: 'ReccomendationCard',
  components: { Card }
}
</script>



// WEBPACK FOOTER //
// src/components/Cards/StatCards/ReccomendationsRow/ReccomendationCard.vue